import localStorageHelper from '@/helpers/local-storage-helper';
import AppConstants from '@/appConstants';
import userService from '@/providers/userService';
import updateDomHelper from '@/helpers/update-dom-helper';
import newsService from '@/providers/newsService';

export default {
  namespaced: true,
  state: {
    currentUser: null,
    isAuthenticated: false,
    currentOrigin: null,
    userCore: null
  },
  getters: {},
  mutations: {
    UPDATE_CURRENT_USER(state, val) {
      state.currentUser = val;
    },
    UPDATE_USER_AUTHENTICATED(state, val) {
      state.isAuthenticated = val;
    },
    UPDATE_CURRENT_ORIGIN(state, val) {
      state.currentOrigin = val;
    },
    UPDATE_USER_CONFIG_SEND_NEWS(state, val) {
      if (state.currentUser.sendNewsConfig != val) {
        // userService.updateUserConfig({ sendNewsConfig: val.join(',') }, new URLSearchParams())
        userService.updateUserConfig({ sendNewsConfig: val }, new URLSearchParams())
          .then(() => {
            state.currentUser.sendNewsConfig = val;
            localStorageHelper.setCurrentUser(state.currentUser);
          })
          .catch(err => console.log(err));
      }
    },
    UPDATE_THEME(state, val) {
      userService.updateUserConfig({ theme: val }, new URLSearchParams())
        .then(() => {
          state.currentUser.theme = val;
          localStorageHelper.setCurrentUser(state.currentUser);

          // Update DOM for dark-layout
          updateDomHelper.updateTheme(val);
        })
        .catch(err => console.log(err));
    },
    UPDATE_ZOOM(state, val) {
      userService.updateUserConfig({ zoom: val }, new URLSearchParams())
        .then(() => {
          state.currentUser.zoom = val;
          localStorageHelper.setCurrentUser(state.currentUser);
          updateDomHelper.updateZoom(val);
        })
        .catch(err => console.log(err));
    },
    UPDATE_LOCALE(state, val) {
      userService.updateUserConfig({ locale: val }, new URLSearchParams())
        .then(() => {
          state.currentUser.locale = val;
          localStorageHelper.setCurrentUser(state.currentUser);
        })
        .catch(err => console.log(err));
    },
    UPDATE_SUBJECT_VIEWTYPE(state, val) {
      userService.updateUserConfig({ subjectViewType: val }, new URLSearchParams())
        .then(() => {
          state.currentUser.subjectViewType = val;
          localStorageHelper.setCurrentUser(state.currentUser);
        })
        .catch(err => console.log(err));
    },
    SET_USERCORE_DATA(state, val) {
      state.userCore = val;
    },
    UPDATE_USERCORE_DATA(state) {
      newsService.getDetailUserCore(new URLSearchParams())
        .then((res) => {
          state.userCore = res;
        })
        .catch(err => console.log(err));
    },
  },
  actions: {
    successLogin({ commit }, payload) {
      commit('UPDATE_CURRENT_USER', payload);
      commit('UPDATE_USER_AUTHENTICATED', true);
      // commit('UPDATE_CURRENT_ORIGIN', payload.origin[0]);

      localStorageHelper.setCurrentUser(payload);
      localStorageHelper.saveData(AppConstants.LOCAL_STORAGE_HAS_LOGGED_IN, true);
      // localStorageHelper.saveData(AppConstants.LOCAL_STORAGE_CURRENT_ORIGIN, JSON.stringify(payload.origin[0]));
      // console.log('success login dispatch');
    },
    updateDataLocalStorage({ commit }) {
      commit('UPDATE_CURRENT_USER', localStorageHelper.getCurrentUser());
      commit('UPDATE_USER_AUTHENTICATED', localStorageHelper.getUserHasLoggedIn());
      // commit('UPDATE_CURRENT_ORIGIN', localStorageHelper.getCurrentOrigin());
      // console.log('updateDataLocalStorage dispatch');
    },
    logout({ commit }) {
      commit('UPDATE_CURRENT_USER', null);
      commit('UPDATE_USER_AUTHENTICATED', false);
      // commit('UPDATE_CURRENT_ORIGIN', null);
      localStorageHelper.removeItem(AppConstants.LOCAL_STORAGE_HAS_LOGGED_IN);
      localStorageHelper.removeItem(AppConstants.LOCAL_STORAGE_CURRENT_USER);
      localStorageHelper.removeItem(AppConstants.LOCAL_STORAGE_CURRENT_ORIGIN);
      // console.log('loggout dispatch');
    },
    // updateCurrentOrigin({ commit }, payload) {
    //   // commit('UPDATE_CURRENT_ORIGIN', payload);
    //   localStorageHelper.saveData(AppConstants.LOCAL_STORAGE_CURRENT_ORIGIN, JSON.stringify(payload));
    // },
    updateTheme({ commit }, payload) {
      commit('UPDATE_THEME', payload);
    },
    updateCurrentUser({ commit }, payload) {
      commit('UPDATE_CURRENT_USER', payload);
      localStorageHelper.setCurrentUser(payload);
    },
    updateZoom({ commit }, payload) {
      commit('UPDATE_ZOOM', payload);
    },
    updateLocale({ commit }, payload) {
      commit('UPDATE_LOCALE', payload);
    },
    updateSubjectViewType({ commit }, payload) {
      commit('UPDATE_SUBJECT_VIEWTYPE', payload);
    },
    setUserCore({ commit }, payload) {
      commit('SET_USERCORE_DATA', payload);
    },
    // updateUserAuthenticated({ commit }, payload) {},
  },
}
